import { PersonalDashboard } from '../components/Dashboard/PersonalDashboard';

export function PersonalDashboardPage() {
  return <PersonalDashboard />;
}
